module.exports = __webpack_public_path__ + "static/media/Chelsea - Pastel.811399f9.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/Chelsea - Pastel.jpg
 ** module id = 389
 ** module chunks = 0
 **/